import { axiosInstance } from ".";

const getSpecialtyList = async (params) =>
  await axiosInstance.get("/specialties", { params });

const addSpecialty = async (payload) =>
  await axiosInstance.post("/specialties", payload);

const getSpecialtyDetails = async (id) =>
  await axiosInstance.get(`/specialties/${id}`);

const editSpecialty = async ({ id, data }) =>
  await axiosInstance.put(`/specialties/${id}`, data);

const deleteSpecialty = async ({ id }) =>
  await axiosInstance.delete(`/specialties/${id}`);

export {
  getSpecialtyList,
  addSpecialty,
  getSpecialtyDetails,
  editSpecialty,
  deleteSpecialty,
};
